var render, staticRenderFns
import script from "./VehicleDwellTime.vue?vue&type=script&lang=js"
export * from "./VehicleDwellTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b51413c",
  null
  
)

export default component.exports